import parseHtml from "html-react-parser";
import Head from "next/head";
import { useRouter } from "next/router";
import constants from "src/constants";
import { OgData } from "src/functions/getOg";

type Props = {
  data: OgData;
};

const productionHeaderTags = `
  <meta name="facebook-domain-verification" content="hv8prnhvu2ofkcxcaa7ivls15gsbz8" />

  <!-- Facebook Pixel Code -->
  <script>
    !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window, document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init', '300079365168860');fbq('track', 'PageView');
  </script>

  <noscript>
    <img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=300079365168860&ev=PageView&noscript=1" />
  </noscript>
  <!-- End Facebook Pixel Code -->

  <!-- Google Tag Manager -->
  <script>
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0], j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${constants.Marketing.gtmId}');
  </script>
  <noscript>
    <iframe src="https://www.googletagmanager.com/ns.html?id=${constants.Marketing.gtmId}" height="0" width="0" style="display:none;visibility:hidden"></iframe>
  </noscript>
  <!-- End Google Tag Manager (noscript) -->

  <!-- Global site tag (gtag.js) - Google Analytics -->
  <script async src="https://www.googletagmanager.com/gtag/js?id=${constants.Marketing.gaId}"></script>

  <script>
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${constants.Marketing.gaId}');
  </script>

  <script>
    !function(t,e){var o,n,p,r;e.__SV||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split(".");2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}(p=t.createElement("script")).type="text/javascript",p.async=!0,p.src=s.api_host+"/static/array.js",(r=t.getElementsByTagName("script")[0]).parentNode.insertBefore(p,r);var u=e;for(void 0!==a?u=e[a]=[]:a="posthog",u.people=u.people||[],u.toString=function(t){var e="posthog";return"posthog"!==a&&(e+="."+a),t||(e+=" (stub)"),e},u.people.toString=function(){return u.toString(1)+".people (stub)"},o="capture identify alias people.set people.set_once set_config register register_once unregister opt_out_capturing has_opted_out_capturing opt_in_capturing reset isFeatureEnabled onFeatureFlags".split(" "),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);
    posthog.init('phc_m7yOwlJxc0ENnAngk6j3R8hycDhC5t6quoYdtjpsyPh',{api_host:'https://app.posthog.com'})
  </script>

  <script type="text/javascript" src="https://secure.payu.com/javascript/sdk"></script>
`;

const payuHeadersTags =
  process.env.NODE_ENV === "development"
    ? `<script type="text/javascript" src="https://secure.snd.payu.com/javascript/sdk"></script>`
    : `
     <script type="text/javascript" src="https://secure.payu.com/javascript/sdk"></script>
`;

export default function Headers({ data }: Props) {
  const { asPath } = useRouter();
  const isCart = asPath === "/cart";

  return (
    <Head>
      <title>{data.title}</title>
      <link rel="shortcut icon" href="/favicon.png" />
      {data.metas.map((meta, index) => {
        return (
          <meta key={index} property={meta.property} content={meta.content} />
        );
      })}
      <link
        rel="stylesheet"
        href="https://maxcdn.bootstrapcdn.com/bootstrap/4.5.0/css/bootstrap.min.css"
        integrity="sha384-9aIt2nRpC12Uk9gS9baDl411NQApFmC26EwAOH8WgZl5MYYxFfc+NcPb1dKGj7Sk"
        crossOrigin="anonymous"
      />
      <link
        rel="stylesheet"
        type="text/css"
        charSet="UTF-8"
        href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
      />
      <link
        rel="stylesheet"
        type="text/css"
        href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
      />

      {process.env.NODE_ENV !== "development" &&
        parseHtml(productionHeaderTags)}
      {isCart && parseHtml(payuHeadersTags)}
    </Head>
  );
}
